module.exports = __webpack_public_path__ + "f066c13eb4967538d831c4203bc63c81.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/Carroussel/widget/5empereurs.png
// module id = 194
// module chunks = 0